<template>
    <teleport to="body">
        <div class="md:max-w-1/2 fixed right-0 top-24 z-50 justify-end">
            <div class="">
                <transition-group name="flash" :appear="true" tag="div">
                    <div
                        class="mx-12 mb-2"
                        v-for="(message, index) in messages"
                        :key="'flash_' + index"
                    >
                        <div class="ml-auto flex justify-end">
                            <div
                                :class="
                                    'message z-50 flex max-w-5xl flex-shrink items-center gap-4 rounded px-3 py-2 text-[15px] shadow' +
                                    ' ' +
                                    colors[message.type]
                                "
                            >
                                <div v-if="message.type==='success'">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <div v-if="message.type==='error'">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                                    </svg>

                                </div>
                                <div v-if="message.type==='info'">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                    </svg>
                                </div>


                                <span v-html="message.text" />
                                <div
                                    class="ml-auto"
                                    @click="clearMessage(index)"
                                >
                                    <svg
                                        class="opacity-80 hover:cursor-pointer hover:opacity-100"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M0.557783 0.55781C0.674971 0.440768 0.833824 0.375027 0.99945 0.375027C1.16508 0.375027 1.32393 0.440768 1.44112 0.55781L5.99945 5.11614L10.5578 0.55781C10.615 0.496404 10.684 0.447153 10.7607 0.412993C10.8373 0.378833 10.9201 0.360465 11.004 0.358984C11.0879 0.357503 11.1713 0.37294 11.2491 0.404375C11.3269 0.435809 11.3976 0.482596 11.457 0.541945C11.5163 0.601294 11.5631 0.671989 11.5946 0.749812C11.626 0.827635 11.6414 0.910993 11.6399 0.994912C11.6385 1.07883 11.6201 1.16159 11.5859 1.23826C11.5518 1.31492 11.5025 1.38393 11.4411 1.44114L6.88278 5.99948L11.4411 10.5578C11.5025 10.615 11.5518 10.684 11.5859 10.7607C11.6201 10.8374 11.6385 10.9201 11.6399 11.004C11.6414 11.088 11.626 11.1713 11.5946 11.2491C11.5631 11.327 11.5163 11.3977 11.457 11.457C11.3976 11.5164 11.3269 11.5631 11.2491 11.5946C11.1713 11.626 11.0879 11.6414 11.004 11.64C10.9201 11.6385 10.8373 11.6201 10.7607 11.586C10.684 11.5518 10.615 11.5025 10.5578 11.4411L5.99945 6.88281L1.44112 11.4411C1.32264 11.5515 1.16593 11.6116 1.00401 11.6088C0.842097 11.6059 0.687609 11.5403 0.573098 11.4258C0.458588 11.3113 0.392994 11.1568 0.390138 10.9949C0.387281 10.833 0.447383 10.6763 0.557783 10.5578L5.11612 5.99948L0.557783 1.44114C0.440741 1.32396 0.375 1.1651 0.375 0.999477C0.375 0.833851 0.440741 0.674998 0.557783 0.55781Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition-group>
            </div>
        </div>
    </teleport>
</template>

<script>
export default {
    name: "FlashMessages",
    data() {
        return {
            messages: [],
            colors: {
                info: "bg-gray-700 text-white",
                success: "bg-success-default text-white",
                error: "bg-danger-default text-white",
            },
        };
    },
    methods: {
        clearMessage(message) {
            this.messages.splice(this.messages.indexOf(message), 1);
        },
        showAlerts() {
            let vm = this;
            let messages = [];

            if (vm.$page.props.flash.success) {
                if (typeof vm.$page.props.flash.success === "string") {
                    messages.push({
                        type: "success",
                        text: vm.$page.props.flash.success,
                        timeout: 5,
                    });
                } else {
                    vm.$page.props.flash.success.forEach(function (item) {
                        messages.push({
                            type: "success",
                            text: item.message,
                            timeout: item.timeout,
                        });
                    });
                }
            }

            if (vm.$page.props.flash.error) {
                if (typeof vm.$page.props.flash.error === "string") {
                    messages.push({
                        type: "error",
                        text: vm.$page.props.flash.error,
                        timeout: 20,
                    });
                } else {
                    vm.$page.props.flash.error.forEach(function (item) {
                        messages.push({
                            type: "error",
                            text: item.message,
                            timeout: item.timeout,
                        });
                    });
                }
            }

            if (vm.$page.props.flash.info) {
                if (typeof vm.$page.props.flash.info === "string") {
                    messages.push({
                        type: "info",
                        text: vm.$page.props.flash.info,
                        timeout: 5,
                    });
                } else {
                    vm.$page.props.flash.info.forEach(function (item) {
                        messages.push({
                            type: "info",
                            text: item.message,
                            timeout: item.timeout,
                        });
                    });
                }
            }

            vm.messages = messages;

            vm.messages.forEach(function (message, index) {
                if (message.timeout !== 0) {
                    setTimeout(function () {
                        if (message.type === "success" || message.type === "info") {
                            vm.clearMessage(message);
                        }
                    }, (message.timeout * 1000) + (250 * index));
                }
            });
        },
    },
    mounted() {
        this.showAlerts();
    },
    watch: {
        "$page.props.flash": {
            handler(newValue, oldValue) {
                this.showAlerts();
            },
            deep: true,
        },
    },
};
</script>

<style scoped>
.flash-move,
.flash-enter-active,
.flash-leave-active {
    transition: all 0.75s;
}

.flash-enter-from,
.flash-leave-to {
    transform: translateY(-20px);
    opacity: 0;
}
</style>
